<template>
  <div class="top" :class="transparent" v-if="menu.length">
    <div :class="logo" @click="goToHome"></div>
    <navigation-menu></navigation-menu>
    <sidebar></sidebar>
	<disclaimer v-if="showDisclaimer"></disclaimer>
  </div>
</template>

<script>
import NavigationMenu from "./NavigationMenu";
import Disclaimer from "./Disclaimer";
import Sidebar from "./sidebar/Sidebar";
import { getMenu, getSearchTerms } from "./NavigationActions";

export default {
  vuex: {
    getters: {
      scroll: state => state.scrolled,
      menu: state => state.menu,
      showDisclaimer: state => state.showDisclaimer
    },
    actions: {
      toggle: ({ dispatch }, id, sidebar) => dispatch("MENU_ITEM_CHANGED", id, sidebar), getMenu, getSearchTerms
    }
  },
  components: { NavigationMenu, Sidebar, Disclaimer },

  ready () {
    this.getMenu();
    this.getSearchTerms();
  },

  computed: {
    transparent () {
      return (this.$route.path === "/" && !this.scroll) ? "transparent" : "";
    },
    logo () { return (this.$route.path === "/" && !this.scroll) ? "logo-white" : "logo"; }
  },

  methods: {
    goToHome () {
      document.location.href = "/";
    }
  },

  events: {
    "submenu_clicked": function (id, sidebar) {
      this.toggle(id, sidebar);
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';
  
  .top{
    position: fixed;
    width: 100%;
    height: 72px;
    box-sizing: border-box;
    z-index: 1000;
    background: $white;
    border-bottom: 1px solid $green_light;


    &.transparent{
      background: transparent;
      border-bottom: none;
    }
  }

</style>



// WEBPACK FOOTER //
// Navigation.vue?3c240a56